import { render, staticRenderFns } from "./CommunicationDetailsLayer.vue?vue&type=template&id=10a438b2&scoped=true&"
import script from "./CommunicationDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationDetailsLayer.vue?vue&type=style&index=0&id=10a438b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a438b2",
  null
  
)

export default component.exports